import React from 'react';
import { Dialog as MuiDialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

import * as styles from './Dialog.scss';

/**
 * @class Dialog
 * @classdesc Reusable Dialog Component based on MUI's Dialog component
 */
const Dialog = (props) => {
  const {
    open,
    onClose,
    title,
    actions,
    children,
    maxWidth = 'xs',
    fullWidth,
  } = props;

  return (
    <MuiDialog
      className={styles.dialog}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      open={open}
      onClose={onClose}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {children}
      </DialogContent>
      {actions && <DialogActions sx={{ mt: 0, pt: 0, pb: 3, px: 3 }}>{actions}</DialogActions>}
    </MuiDialog>
  );
};

export default Dialog;
